<script>
import {BCard, BCardTitle, BBadge} from 'bootstrap-vue'
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import {
    CandidateListDetails, RoHSDetails, POPsDetails, MaxConcentrationExemptionDetails
} from "@/views/product/components/product-card/composition/substance/details/view";
import {SubstanceLists} from "@/libs/substance";
import {getAllSubstanceLists} from "@core/domain/substance";

export default {
    components: {AppCollapse, AppCollapseItem, BCard, CandidateListDetails, RoHSDetails, POPsDetails,
        MaxConcentrationExemptionDetails, BCardTitle, BBadge
    },
    props: {
        compactView: {
            type: Boolean,
            default: false
        },
        substance: {
            type: Object,
            default() {
                return {
                    substance: {
                        title: ''
                    },
                    details: {
                        list: {},
                        details: []
                    },
                };
            }
        },
        mode: {
            required: true
        }
    },
    data() {
        const map = {};
        map[SubstanceLists.CANDIDATE_LIST] = 'CandidateListDetails';
        map[SubstanceLists.ROHS] = 'RoHSDetails';
        map[SubstanceLists.POPS] = 'POPsDetails';
        return {
            substanceListComponentMap: map,
            substanceLists: [],
        };
    },
    computed: {
        substanceDetails() {
            const result = {};
            Object.keys(this.substance.details).forEach(key => {
                const list = this.substanceLists.find(l => l.key === key);
                if (list && list.isExternal(this.substance.substance)) {
                    return;
                }
                result[key] = this.substance.details[key];
            });
            return result;
        }
    },
    created() {
        getAllSubstanceLists().then(lists => {
            Promise.all(
                lists.map(list => list.loadSubstances())
            ).then(() => {
                this.substanceLists = lists;
                lists.forEach(list => {
                    if (!this.substanceListComponentMap.hasOwnProperty(list.key)) {
                        this.substanceListComponentMap[list.key] = 'MaxConcentrationExemptionDetails';
                    }
                });
            })
        });
    }
}
</script>

<template>
    <b-card
        :title="substance.substance.title"
        bg-variant="light"
    >
        <div class="pb-1">
            <b-badge class="mr-1">CAS: {{ substance.substance.cas }}</b-badge>
            <b-badge>EC: {{ substance.substance.ec }}</b-badge>
        </div>

        <AppCollapse
            type="border"
        >
            <AppCollapseItem
                v-for="(details, name) in substanceDetails"
                :title="details.list.title"
                is-visible
                :is-collapsible="false"
            >
                <component
                    v-if="substanceListComponentMap.hasOwnProperty(name)"
                    :is="substanceListComponentMap[name]"
                    v-bind="{substance: substance.substance, details: details.details, mode: mode}"
                />
            </AppCollapseItem>
        </AppCollapse>
    </b-card>
</template>

<style scoped lang="scss">

</style>
